import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import CoreInput from "../../core/inputs/CoreInput";
import CoreButton from "../../core/inputs/CoreButton";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreJsonEditor from "../../core/inputs/CoreJsonEditor";
import CoreAutoComplete from "../../core/inputs/CoreAutoComplete";
import { useDispatch, useSelector } from "react-redux";
import AsyncSelect from "react-select/async";
import CoreAsyncSelect from "../../core/inputs/CoreAsyncSelect";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  maxHeight: 570,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
};

const objectCol = ["extraInfo"];
const dropDownCol = ["_status", "type"];
const asyncSelectCol = ["parentId"];

export default function MasterDataEditModal({
  show,
  value,
  col,
  options = [],
  asyncSelectDetail = {},
  onClose,
  onSubmit,
}) {
  const [localValue, setLocalValue] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(show);
  }, [show]);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const onChange = (e) => {
    setLocalValue(e.target.value);
  };

  const onLocalSubmit = (e) => {
    e.preventDefault();
    onSubmit(localValue);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {objectCol?.includes(col) ? (
          <CoreJsonEditor
            value={localValue}
            onSubmit={(value) => {
              onSubmit(value);
            }}
          />
        ) : dropDownCol?.includes(col) ? (
          <CoreAutoComplete
            style={{ width: "100%" }}
            value={localValue}
            onChange={(id, val) => {
              setLocalValue(val?.value);
            }}
            options={options}
            label={col}
          />
        ) : asyncSelectCol?.includes(col) ? (
          <CoreAsyncSelect
            onChange={(val) => {
              setLocalValue(val?.value);
            }}
            value={localValue}
            {...asyncSelectDetail}
          />
        ) : (
          <CoreInput
            autoFocus={true}
            label={col}
            value={localValue || ""}
            onChange={onChange}
          />
        )}

        {!col?.includes(objectCol) && (
          <CoreButtonContainer>
            <CoreButton onClick={onLocalSubmit}>Submit</CoreButton>
          </CoreButtonContainer>
        )}
      </Box>
    </Modal>
  );
}
